import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { PaymentElement, useElements } from '@stripe/react-stripe-js';
import useViewer from '@hooks/useViewer';

const CartPaymentElementWrapper = ({
    paymentIntentSecret,
    selectedPayment,
    setStripeCardComplete,
    setStripeElements,
}) => {
    const viewer = useViewer();
    const elements = useElements();

    useEffect(() => {
        if (!elements || !setStripeElements) return null;
        setStripeElements(elements);
    }, [elements, setStripeElements]);

    if (!paymentIntentSecret || !selectedPayment || !viewer) {
        return null;
    }

    return (
        <>
            <PaymentElement
                options={{
                    layout: {
                        type: 'accordion',
                        spacedAccordionItems: true,
                    },
                    paymentMethodOrder: ['apple_pay', 'google_pay', 'card'],
                    readOnly: selectedPayment !== 'new',
                }}
                onChange={e => setStripeCardComplete(e.complete)}
            />
        </>
    );
};

CartPaymentElementWrapper.propTypes = {
    paymentIntentSecret: PropTypes.string,
    selectedPayment: PropTypes.string, // or whatever type is appropriate
    setStripeCardComplete: PropTypes.func,
    setStripeElements: PropTypes.func,
};

export default CartPaymentElementWrapper;
